/* eslint-disable react/jsx-curly-brace-presence */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import {
  clarityTuitionApiUsers,
  customers,
  modals
} from 'ducks';
import { duckify, singleDuck } from 'utils/duckify';
import Placeholder from '../Placeholder';
import { formatDateTime } from '../../utils';
import ApiCredentialsModal from '../ApiCredentials/ApiCredentialsModal';

const ClarityTuitionConfig = (props) => {
  const {
    allDucksReady,
    createUser,
    customer,
    destroyAllUsers,
    users
  } = props;

  const [detailUser, setDetailUser] = useState(null);
  const [clarityIsEnabled, setClarityIsEnabled] = useState(false);

  useEffect(() => {
    setClarityIsEnabled(false);
    if (customer.modules.includes('external_api') && users.length > 0) {
      setClarityIsEnabled(true);
    }
  }, [users]);

  return (
    <React.Fragment>
      <h2>Clarity Tuition Integration</h2>
      {allDucksReady &&
        <div> {clarityIsEnabled ?
          <div>
            <table className={'api-users-table table'}>
              <thead>
              <tr>
                <th>User ID</th>
                <th className={'api-users-table-description'}>Description</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
              </thead>
              <Placeholder.table
                ready={users.ready}
                content={() => (
                  <tbody>
                  {users.map(user => (
                    <tr key={user.id}>
                      <td>{user.id}</td>
                      <td>
                        {user.description}
                      </td>
                      <td>{formatDateTime(user.created_at)}</td>
                      <td>
                        <Button
                          variant={'link'}
                          onClick={() => setDetailUser(user)}
                        >
                          View Details
                        </Button>
                      </td>
                    </tr>
                  ))}
                  </tbody>
                )}
              />
            </table>
            <div>Note: Disabling the Clarity Tuition Integration deletes the current Clarity Tuition Write API Key.</div><br/>
            <div><a className="btn btn-primary" onClick={() => destroyAllUsers()}>Disable</a></div>
            {detailUser && <ApiCredentialsModal apiUser={detailUser} onClose={() => setDetailUser(null)} />}
          </div> :
          <div>
            <div>Enable the Clarity Tuition Integration to create an External API key with write access to Clarity Tuition fields.</div><br/>
            <div><a className="btn btn-primary" onClick={() => createUser()}>Enable</a></div>
          </div>
        }</div>
      }
    </React.Fragment>
  );
};

ClarityTuitionConfig.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    roles: PropTypes.arrayOf(PropTypes.string),
    created_at: PropTypes.string
  })).isRequired,
  createUser: PropTypes.func.isRequired,
  destroyAllUsers: PropTypes.func.isRequired
};

const mapDucksToProps = () => ({
  users: clarityTuitionApiUsers,
  customer: singleDuck(customers, 'current')
});

const mapDispatchToProps = (dispatch) => ({
  createUser: () => dispatch(clarityTuitionApiUsers.actions.create())
    .then((response) => {
      if (response.result) {
        dispatch(customers.actions.markDirty());
        return dispatch(clarityTuitionApiUsers.actions.markDirty());
      } else {
        const error = response.payload || response.error || new Error('Unknown error during create.');
        dispatch(modals.actions.show('UnexpectedError', { message: error.message || error.toString() }));
        return Promise.reject(error);
      }
    })
    .catch(error => {
      dispatch(modals.actions.show('UnexpectedError', { message: error.message || "Failed to enable Clarity Tuition Integration." }));
    }),
  destroyAllUsers: () => (
    dispatch(modals.actions.show('VerificationModal', {
      title: 'Confirm Disable Clarity Tuition Integration',
      message: (
        <div>
          <h2>Are you sure you want to disable the Clarity Tuition Integration?</h2>
          <p>
            The current Clarity Tuition External API key will be deleted
            and all External API keys will have the Clarity Integration
            permissions removed.
          </p>
        </div>
      ),
      onConfirm: () => dispatch(clarityTuitionApiUsers.actions.destroyAllUsers())
        .then((response) => {
          if (response.result) {
            return dispatch(clarityTuitionApiUsers.actions.markDirty());
          } else {
            const error = response.payload || response.error || new Error('Unknown error during destroy.');
            dispatch(modals.actions.show('UnexpectedError', { message: error.message || error.toString() }));
            return Promise.reject(error);
          }
        })
        .catch(error => {
          dispatch(modals.actions.show('UnexpectedError', { message: error.message || "Failed to disable Clarity Tuition Integration." }));
        })
    }))
  )
});

export default duckify(mapDucksToProps, () => ({}), mapDispatchToProps)(ClarityTuitionConfig);
